import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="4" y="5" width="16" height="2" rx="0" fill="white" />
			<rect x="4" y="8" width="16" height="2" rx="0" fill="white" />
			<rect x="4" y="11" width="16" height="2" rx="0" fill="white" />
			<path
				d="M17 6 L19 8 L17 10"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<rect x="4" y="14" width="16" height="2" rx="0" fill="white" />
			<rect x="4" y="17" width="16" height="2" rx="0" fill="white" />
			<path
				d="M17 15 L15 17 L17 19"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
	return icon;
}

export default icon;
